import { Routes } from '@angular/router';
import { LoginComponent } from './pages/login/login.component';
import { CallbackComponent } from './pages/callback/callback.component';
import { LogoutComponent } from './pages/logout/logout.component';
import { RedirectComponent } from './pages/redirect/redirect.component';
import { BlankLayoutComponent } from '../layout/pages/blank-layout/blank-layout.component';

export const authRoutes: Routes = [
  {
    path: 'auth',
    component: BlankLayoutComponent,
    children: [
      {
        path: '',
        redirectTo: 'login',
        pathMatch: 'full',
      },
      {
        path: 'login',
        component: LoginComponent,
      },
      {
        path: 'callback',
        component: CallbackComponent,
      },
      {
        path: 'logout',
        component: LogoutComponent,
      },
      {
        path: 'redirect',
        component: RedirectComponent,
      },
    ],
  },
  { path: '**', redirectTo: 'login', pathMatch: 'full' },
];
